import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import slide1 from "../../assets/images/webisteimage/1.jpg";
import slide2 from "../../assets/images/webisteimage/2.jpg";
import slide5 from "../../assets/images/webisteimage/5.jpg";
import slide6 from "../../assets/images/webisteimage/6.jpg";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.css";
import { SliderImage } from "./styles";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default function App() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={slide1} alt="First Slide" style={{ height: 600, width: "100%" }} />
        </SwiperSlide>
        {/* <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src="https://firebasestorage.googleapis.com/v0/b/najmat-fcf50.appspot.com/o/images%2F3.jpg?alt=media&token=9da8a9c1-6a3a-458c-9b8b-c912d4b2a329" />
        </SwiperSlide> */}
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src={slide2} />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src={slide5} />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src={slide6} />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src={slide1} />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <img src={slide2} />
        </SwiperSlide>
        {/* <SwiperSlide style={{ height: 600, width: "100%" }}>
          <SliderImage />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <SliderImage />
        </SwiperSlide>
        <SwiperSlide style={{ height: 600, width: "100%" }}>
          <SliderImage />
        </SwiperSlide> */}
      </Swiper>
    </>
  );
}
